/*
 * @Author: zhaozhuo
 * @Date: 2022-02-18 11:55:18
 * @LastEditors: zhaozhuo
 * @LastEditTime: 2022-03-17 16:12:16
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\store\doctor\actions.js
 */
import * as MUTATIONTYPES from '../mutationTypes'
import api from '@/request'
const actions = {
	// 获取患者添加的配置
	getSubjectAddedInfoAction({ commit }, params) {
		return new Promise((resolve, reject) => {
			api.subject.getSubjectAddedInfo(params.researchCode).then((res) => {
				if (res && res.code === 200) {
					const testeeInfo = params || {}
					const testeeGroupList = (res.data.subjectGroupVoList || []).map(item => {
						const testeeGroupLabel = ''
						return { ...item, groupValue: testeeInfo[item.groupCode] ? testeeInfo[item.groupCode] : '', groupLabel: testeeInfo[item.groupCode] ? testeeGroupLabel : '', groupFlag: false }
					})
					const testeeFormList = (res.data.subjectSettingVoList || []).map((item) => {
						item.isPopFlag = false
						return item
					})
					commit(MUTATIONTYPES.SETTESTEEFORM, { testeeGroupList, ...testeeInfo })
					commit(MUTATIONTYPES.SETTESTEEDETAIL, { testeeFormList, testeeGroupList, numberGenerationMode: res.data.numberGenerationMode })
					resolve(res.data)
				} else {
					commit(MUTATIONTYPES.SETTESTEEDETAIL, { testeeFormList: [] })
					commit(MUTATIONTYPES.SETTESTEEFORM, { ...params, subjectNumber: '' })
					reject()
				}
			})
		}).catch(() => {
		})
	}
}
export default actions